export const presets = [
  // Shauna Coxsey
  {
    name: "Shauna Coxsey",
    imgName: "shauna-coxsey-no-bg.png",
    colour: "#c22b2b",
    downloadPrefix: "shauna-2",
    resets: [
      {
        label: "closeCrop",
        url: "?backgroundColour=rgb%28247%2C%20235%2C%20238%2C%201%29&baseColour=%23c22b2b&blockSize=10&brightnessAdjust=5&contrast=0&countLightestColour=0&cropBottom=0.76&cropLeft=0.32&cropRight=0.76&cropTop=0.1&paperType=A5_portrait&pixelsWide=84&preset=Shauna%20Coxsey&removeLightestColour=0&sharpnessAdjust=4&showInfo=1&showSheets=1&totalColours=7",
      },
    ],
  },

  {
    name: "Shauna Coxsey - custom hues",
    imgName: "shauna-coxsey-no-bg.png",
    colour: "#5ac12a",
    downloadPrefix: "shauna-coxsey",
    resets: [
      {
        label: "custom hues",
        url: "?backgroundColour=rgb%28247%2C+235%2C+238%2C+1%29&baseColour=%23c22b2b&blockSize=10&brightnessAdjust=5&contrast=0&countLightestColour=0&cropBottom=0.76&cropLeft=0.32&cropRight=0.76&cropTop=0.1&paperType=A5_portrait&pixelsWide=84&preset=Shauna+Coxsey&removeLightestColour=0&sharpnessAdjust=4&showInfo=1&showSheets=0&totalColours=7",
      },
    ],
  },

  // Wainwright
  {
    name: "Wainwright",
    imgName: "Alfred-Wainwright-no-bg.png",
    colour: "#7ba048",
    downloadPrefix: "Wainwright_green",
    resets: [
      {
        label: "closeCrop",
        url: "?backgroundColour=rgb%28192%2C%20206%2C%20173%2C%201%29&baseColour=%237ba048&blockSize=12&brightnessAdjust=-2&contrast=2&countLightestColour=0&cropBottom=0.5&cropLeft=0.24&cropRight=0.7&cropTop=0.07&paperType=A5_portrait&pixelsWide=73&preset=Wainwright&removeLightestColour=0&sharpnessAdjust=2&showInfo=1&showSheets=1&totalColours=16",
      },
    ],
  },

  //   DOROTHY
  {
    name: "topLeftDorothy",
    imgName: "top-left.png",
    colour: "#5ac12a",
    downloadPrefix: "Dorothy_Wordsworth_green",
    resets: [
      {
        label: "asUsedInSchool",
        url: `?backgroundColour=rgb%28255%2C+255%2C+255%2C+1%29&baseColour=%235ac12a&blockSize=12&brightnessAdjust=-8&contrast=0&countLightestColour=0&cropBottom=0.92&cropLeft=0.13&cropRight=0.87&cropTop=0.16&paperType=A5_portrait&pixelsWide=72&preset=topLeftDorothy&removeLightestColour=0&showInfo=1&showSheets=0&totalColours=16`,
      },
    ],
  },

  {
    name: "topRightDorothy",
    imgName: "top-right.png",
    colour: "#9a2048",
    downloadPrefix: "Dorothy_Wordsworth_maroon",
    resets: [
      {
        label: "asUsedInSchool",
        url: `?backgroundColour=rgb%28255%2C%20255%2C%20255%2C%201%29&baseColour=%239a2048&blockSize=12&brightnessAdjust=-8&contrast=0&countLightestColour=0&cropBottom=0.92&cropLeft=0.13&cropRight=0.87&cropTop=0.16&paperType=A5_portrait&pixelsWide=72&preset=topRightDorothy&removeLightestColour=0&showInfo=1&showSheets=0&totalColours=16`,
      },
    ],
  },

  {
    name: "bottomRightDorothy",
    imgName: "bottom-right.png",
    colour: "#7012a3",
    downloadPrefix: "Dorothy_Wordsworth_purple",
    resets: [
      {
        label: "asUsedInSchool",
        url: `?backgroundColour=rgb%28255%2C%20255%2C%20255%2C%201%29&baseColour=%237012a3&blockSize=12&brightnessAdjust=-8&contrast=0&countLightestColour=0&cropBottom=0.92&cropLeft=0.13&cropRight=0.87&cropTop=0.16&paperType=A5_portrait&pixelsWide=72&preset=bottomRightDorothy&removeLightestColour=0&showInfo=1&showSheets=0&totalColours=16`,
      },
    ],
  },

  {
    name: "bottomLeftDorothy",
    imgName: "bottom-left.png",
    colour: "#ffa200",
    downloadPrefix: "Dorothy_Wordsworth_orange",
    resets: [
      {
        label: "asUsedInSchool",
        url: `?backgroundColour=rgb%28255%2C%20255%2C%20255%2C%201%29&baseColour=%23ffa200&blockSize=12&brightnessAdjust=-8&contrast=0&countLightestColour=0&cropBottom=0.92&cropLeft=0.13&cropRight=0.87&cropTop=0.16&paperType=A5_portrait&pixelsWide=72&preset=bottomLeftDorothy&removeLightestColour=0&showInfo=1&showSheets=0&totalColours=16`,
      },
    ],
  },
];
